<script setup lang="ts">
import { ConfirmDialog } from '@forgd/ui-kit/blocks/dialogs'

const emit = defineEmits<{
  confirm: []
}>()

const open = defineModel<boolean>('open', { default: false })
</script>

<template>
  <ConfirmDialog v-model:open="open" title="Discard unsaved changes?" confirm-label="Discard" @confirm="emit('confirm')">
    <p>You have unsaved changes. If you close now, they will be lost.</p>
  </ConfirmDialog>
</template>
